import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrashAlt,
  faCheck,
  faTimes,
} from "@fortawesome/pro-light-svg-icons";
import { FieldArray, Field } from "formik";
import { setManageMasterToastInfo } from "../../../contexts";
import { TimePicker, FieldInput, FieldButtonGroup } from "../../../components";
import { toOptionValuesFromMapper } from "../../../utils";
import { get, isEmpty } from "lodash";
import { UpsertClearanceTime, DeleteClearanceTime } from "../../../services";
import moment from "moment";
// import {  } from "@fortawesome/pro-solid-svg-icons";

export const ClearanceTimeCard = (props) => {
  const {
    clearanceTypeEnum,
    val,
    index,
    setFieldValue,
    values,
    remove,
    clearanceRepsonse,
    handleChange,
    clearanceTypeTime,
    clearingPartnerId,
    dirty,
    dispatch,
  } = props;
  const dt = new Date();
  const [edit, setEdit] = useState(false);

  const setEditGroup = () => {
    console.log(values, "hit");
    // const finalValues = get(values,clearanceRepsonse,[])?.map((e) => ({
    //   ...e,time: new Date(0,0,0,e.processTimeHours,e.processTimeMinutes)
    // }))
    // console.log({...val,time:  moment(new Date(dt.getFullYear(),dt.getMonth(),dt.getDay(),val.processTimeHours,val.processTimeMinutes)).format(),tradingPartnerId:clearingPartnerId},"hithit");
    UpsertClearanceTime({
      ...val,
      time: `${val.processTimeHours}:${val.processTimeMinutes}`,
      tradingPartnerId: clearingPartnerId,
    })
      .then((res) => {
        setEdit(false);
        dispatch(
          setManageMasterToastInfo({
            showToast: true,
            toastMessage: "Data saved successfully",
          })
        );
      })
      .catch((err) => err);
  };
  const deleteClearance = () => {
    DeleteClearanceTime(val.id)
      .then((res) => {
        remove(val);
      })
      .catch((err) => err);
  };

  const setCancel = () => {
    setEdit(false);
    console.log(get(values, `${clearanceRepsonse}.${index}`), dirty);
    setFieldValue(
      "clearingTimeReponses",
      get(values, "clearingTimeReponses", []).filter((e) => e.id != 0)
    );
  };
  return (
    <div className="time-tile">
      {edit || get(values, `${clearanceRepsonse}.${index}.id`, 0) === 0 ? (
        <TimePicker
          setFieldValue={setFieldValue}
          values={get(values, `${clearanceRepsonse}.${index}`)}
          fields={clearanceTypeTime}
          errorMsg={""}
          currentFieldName={`${clearanceRepsonse}.${index}`}
        />
      ) : (
        <div className="time-component">
          {val.processTimeHours + ":" + val.processTimeMinutes}
        </div>
      )}
      <div className="clearance-name">
        {edit || get(values, `${clearanceRepsonse}.${index}.id`, 0) === 0 ? (
          <Field
            size="sm"
            isRequired
            name={`${clearanceRepsonse}.${index}.name`}
            // label={"Clearing Partner ID"}
            type="text"
            autoComplete="off"
            value={get(values, `${clearanceRepsonse}.${index}.name`)}
            onChange={handleChange}
            //   disabled={isAddedToMaster || (isEdit && !isSave)}
            component={FieldInput}
          />
        ) : (
          val.name
        )}
      </div>
      <div className="clearance-type">
        {edit || get(values, `${clearanceRepsonse}.${index}.id`, 0) === 0 ? (
          <Field
            isRequired
            name={`${clearanceRepsonse}.${index}.clearanceType`}
            // label="Account Aggregation Level"
            size="sm"
            options={toOptionValuesFromMapper(clearanceTypeEnum)}
            selectedValue={get(
              values,
              `${clearanceRepsonse}.${index}.clearanceType`,
              0
            )}
            onChange={(value) => {
              setFieldValue(
                `${clearanceRepsonse}.${index}.clearanceType`,
                value
              );
            }}
            // disabled={isEdit && !isSave}
            component={FieldButtonGroup}
          />
        ) : (
          clearanceTypeEnum[val.clearanceType]
        )}
      </div>
      <div className="clearance-action">
        {edit || get(values, `${clearanceRepsonse}.${index}.id`, 0) === 0 ? (
          <FontAwesomeIcon
            icon={faCheck}
            color="#067492"
            style={{ cursor: "pointer" }}
            onClick={setEditGroup}
          />
        ) : (
          <FontAwesomeIcon
            icon={faEdit}
            color="#067492"
            style={{ cursor: "pointer" }}
            onClick={() => setEdit(true)}
          />
        )}
        {edit || get(values, `${clearanceRepsonse}.${index}.id`, 0) === 0 ? (
          <FontAwesomeIcon
            style={{ cursor: "pointer" }}
            onClick={setCancel}
            icon={faTimes}
            color="#C4061A"
          />
        ) : (
          <FontAwesomeIcon
            onClick={deleteClearance}
            icon={faTrashAlt}
            style={{ cursor: "pointer" }}
            color="#C4061A"
          />
        )}
      </div>
    </div>
  );
};
